const state = {
    profitLossItem: null,
    viewBetsItem:null,
    userBonus: null,
    plFilterOption: null

};
const getters = {
    profitLossItem: state => state?.profitLossItem,
    viewBetsItem: state => state?.viewBetsItem,
    userBonus: state => state?.userBonus,
    plFilterOption: state => state?.plFilterOption,

};
const actions = {
    setProfitLossItem({ commit }, profitLossItem) {
        commit('setProfitLossItem', profitLossItem);
    },
    setViewBetsItem({ commit }, viewBetsItem) {
        commit('setViewBetsItem', viewBetsItem);
    },
    setUserBonus({ commit }, userBonus) {
        commit('setUserBonus', userBonus);
    },
    setPlFilterOption({ commit }, plFilterOption) {
        commit('setPlFilterOption', plFilterOption);
    },
};
const mutations = {
    setProfitLossItem(state, profitLossItem) {
        state.profitLossItem = profitLossItem;
    },
    setViewBetsItem(state, viewBetsItem) {
        state.viewBetsItem = viewBetsItem;
    },
    setUserBonus(state, userBonus) {
        state.userBonus = userBonus
    },
    setPlFilterOption(state, plFilterOption) {
        state.plFilterOption = plFilterOption;
    },
};
export default {
    state,
    getters,
    actions,
    mutations
};